import * as Yup from "yup";
import { countrySchema, stateSchema } from "./validations";

const phoneRegex = /^(\+?\d{1,4}[\s-]?)?(\(?\d{2,4}\)?[\s-]?)?[\d\s-]{5,15}$/;

export const addressSaveSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters")
    .max(100, "Name must be at most 100 characters"),
  address1: Yup.string().required("Address line 1 is required"),
  address2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: stateSchema,
  zip: Yup.string().required("ZIP / Postal code is required"),
  country: countrySchema,
  phone: Yup.string()
    .required("Phone number is required")
    .matches(phoneRegex, "Enter a valid phone number"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});
